import { render } from "./Login.vue?vue&type=template&id=12f5395a"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\babay\\Documents\\GitHub\\gosociali-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/Login.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12f5395a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12f5395a', __exports__)) {
    console.log('reload')
    api.reload('12f5395a', __exports__)
  }
  
  module.hot.accept("./Login.vue?vue&type=template&id=12f5395a", () => {
    console.log('re-render')
    api.rerender('12f5395a', render)
  })

}


export default __exports__